import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import DashboardLayout from './components/DashboardLayout';

// Auth
import LoginPage from './pages/LoginPage';

// Dashboard
import DashboardPage from './pages/DashboardPage';

// Cars/Vehicles
import CarsListPage from './pages/CarsListPage';
import CarFormPage from './pages/CarFormPage';

// Leads
import LeadsPage from './pages/LeadsPage';

// Agency Profile
import AgencyProfilePage from './pages/AgencyProfilePage';

// Admin
import AdminAgenciesPage from './pages/admin/AdminAgenciesPage';
import AdminAgencyFormPage from './pages/admin/AdminAgencyFormPage';
import AdminUsersPage from './pages/admin/AdminUsersPage';
import AdminBillingPage from './pages/admin/AdminBillingPage';
import AdminDemosPage from './pages/admin/AdminDemosPage';

// Public
import PublicAgencyPage from './pages/PublicAgencyPage';
import PublicCarDetailPage from './pages/PublicCarDetailPage';

// Landing & Legal
import LandingPage from './pages/LandingPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import CookiesPage from './pages/CookiesPage';
import CookieBanner from './components/CookieBanner';
import AgenciasPage from './pages/AgenciasPage';
import AutosFlowPage from './pages/AutosFlowPage';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          
          <Route path="/app/login" element={<LoginPage />} />
          
          <Route element={<PrivateRoute />}>
            <Route
              path="/app/*"
              element={
                <DashboardLayout>
                  <Routes>
                    <Route path="dashboard" element={<DashboardPage />} />
                    
                    {/* Cars/Vehicles Routes */}
                    <Route path="cars" element={<CarsListPage />} />
                    <Route path="cars/new" element={<CarFormPage />} />
                    <Route path="cars/:id/edit" element={<CarFormPage />} />
                    
                    {/* Leads */}
                    <Route path="leads" element={<LeadsPage />} />
                    
                    {/* Agency Profile */}
                    <Route path="agency" element={<AgencyProfilePage />} />
                    
                    {/* Admin Routes */}
                    <Route path="admin/agencies" element={<AdminAgenciesPage />} />
                    <Route path="admin/agencies/new" element={<AdminAgencyFormPage />} />
                    <Route path="admin/agencies/:id/edit" element={<AdminAgencyFormPage />} />
                    <Route path="admin/users" element={<AdminUsersPage />} />
                    <Route path="admin/billing" element={<AdminBillingPage />} />
                    <Route path="admin/demos" element={<AdminDemosPage />} />
                    
                    <Route path="*" element={<Navigate to="/app/dashboard" replace />} />
                  </Routes>
                </DashboardLayout>
              }
            />
          </Route>

          {/* Public Routes */}
          <Route path="/a/:slug" element={<PublicAgencyPage />} />
          <Route path="/a/:slug/autos" element={<PublicAgencyPage />} />
          <Route path="/a/:slug/autos/:carId" element={<PublicCarDetailPage />} />

          {/* Legal Pages */}
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/cookies" element={<CookiesPage />} />
          <Route path="/agencias" element={<AgenciasPage />} />
          <Route path="/autos-flow" element={<AutosFlowPage />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
